import {
  Text,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Box,
  Flex,
  Center,
  Image,
  Icon,
  ModalCloseButton,
} from '@chakra-ui/react'
import {useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import {EXAM_MODE_TYPE} from '@pages/ExamPage/examPageModel'
import {ReactComponent as ArrowRight} from '@assets/svgs/exam/arrow-right.svg'
import ChillingManIcon from '@assets/svgs/exam/chilling-man.svg'
import GirlReadingIcon from '@assets/svgs/exam/girl-reading-book.svg'

interface IExamModalProps {
  isOpen: boolean
  onClose: () => void
  testId: string
}

function ExamModal(props: Readonly<IExamModalProps>) {
  const navigate = useNavigate()
  const {isOpen, onClose, testId} = props

  const handleNavigateExamRoom = (modeType: any) => {
    let featureName = 'DEMO_TEST_PART_1'
    navigate(PATH.EXAM_ROOM, {
      state: {testId: testId, type: modeType, feature_name: featureName},
    })
  }

  const ModeTypeItem = ({
    type,
    title,
    subtitle,
    description,
    image,
    color,
  }: any) => (
    <Box
      flex={1}
      bg={'white'}
      borderRadius={'20px'}
      cursor={'pointer'}
      onClick={() => handleNavigateExamRoom(type)}>
      <Flex justifyContent={'center'}>
        <Text
          p={{base: '4px 8px', md: '12px 16px'}}
          borderRadius={'0px 0px 12px 12px'}
          bg={color}
          color={'white'}
          fontSize={{
            base: '12px',
            md: '16px',
          }}
          fontWeight={600}>
          {subtitle}
        </Text>
      </Flex>
      <Flex flexDirection={'column'} p={{base: '16px', md: '24px'}}>
        <Center>
          <Image src={image} w={{base: '80px', md: '160px'}} />
        </Center>
        <Center
          flexDirection={'column'}
          gap={'10px'}
          mt={{
            base: '16px',
            md: '24px',
          }}>
          <Text
            fontSize={{
              base: '12px',
              md: '18px',
            }}
            fontWeight={500}>
            {description}
          </Text>
          <Text
            fontSize={{
              base: '14px',
              md: '24px',
            }}
            fontWeight={600}
            color={color}>
            {title}
          </Text>
          <Icon
            w={{base: '18px', md: '24px'}}
            h={{base: '18px', md: '24px'}}
            sx={{
              stroke: color,
            }}>
            <ArrowRight />
          </Icon>
        </Center>
      </Flex>
    </Box>
  )

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true} size={'4xl'}>
      <ModalOverlay />
      <ModalContent
        mx={{base: '16px', md: '24px'}}
        borderRadius={{base: '16px', md: '24px'}}
        bgColor={'#E5F2FF'}>
        <ModalHeader textAlign={'center'} fontSize={{base: '16px', md: '24px'}}>
          Chọn loại phòng bạn muốn
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={{base: '0px 16px 16px 16px', md: '0px 24px 24px 24px'}}>
          <Flex gap={{base: '16px', md: '24px'}}>
            <ModeTypeItem
              type={EXAM_MODE_TYPE.PRACTICE}
              title={'Phòng luyện tập'}
              subtitle={'Thoải mái thời gian'}
              description={'Phòng luyện tập'}
              image={ChillingManIcon}
              color={'#1890FF'}
            />
            <ModeTypeItem
              type={EXAM_MODE_TYPE.DEMO_TEST}
              title={'Phòng thi thử'}
              subtitle={'Áp lực như thật'}
              description={'Phòng thi thử'}
              image={GirlReadingIcon}
              color={'#EC652C'}
            />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ExamModal
